import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Maraton } from '../models/maraton';
@Injectable({
  providedIn: 'root'
})
export class MaratonService {



  constructor(private http: HttpClient) { }

  private maratones: Maraton[];
  private maratones$ = new Subject<Maraton[]>();

  private maraton: Maraton;
  private maraton$ = new Subject<Maraton>();

  change(val) {
    this.maratones = val;
    this.maratones$.next(this.maratones);
  }
  get$(): Observable<Maraton[]> {
    return this.maratones$.asObservable();
  }

  changeOne(val) {
    this.maraton = val;
    this.maraton$.next(this.maraton);
  }
  getOne$(): Observable<Maraton> {
    return this.maraton$.asObservable();
  }

  getAll(): Observable<Maraton[]> {
    return this.http.get(environment.apiUrl + 'maraton')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Maraton[]> {

    return this.http.post(environment.apiUrl + 'maraton/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getLast(): Observable<Maraton> {

    return this.http.get(environment.apiUrl + 'maraton/getLast')
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'maraton/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'maraton', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'maraton';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'maraton/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
}
